import React from 'react';
import PlanTechListContainer from '../../containers/plantechmng/PlanTechListContainer';

const PlanTechListPage = () => {
  return <PlanTechListContainer />;
};

export default PlanTechListPage;
